import axios from 'axios'
import { Notification } from 'element-ui'
import Config from '@/config'
import { getToken } from '@/utils/auth'
import { getSignature } from "@/utils/util";

// 创建axios实例
const service = axios.create({
    timeout: Config.timeout // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        const token = getToken()
        if (token) config.headers['Account-Token'] = token

        const headers = getSignature(config.data, config.url)
        if (headers.cmd5) config.headers['Content-MD5'] = headers.cmd5
        if (headers.authStr) config.headers['X-Authorization'] = headers.authStr

        config.headers['Content-Type'] = "application/json";
        config.data = JSON.stringify(config.data);
        console.log(config)
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        try {
            if (error.response.data.status) {
                const errorMsg = error.response.data.message
                if (errorMsg !== undefined) {
                    Notification.error({
                        title: errorMsg,
                        duration: 5000
                    })
                }
            } else {
                Notification.error({
                    title: '接口请求失败',
                    duration: 5000
                })
            }
        } catch (e) {
            if (error.toString().indexOf('Error: timeout') !== -1) {
                Notification.error({
                    title: '网络请求超时',
                    duration: 5000
                })
                return Promise.reject(error)
            }
        }
        return Promise.reject(error)
    }
)
export default service
